// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.generic-autocomplete {
  flex-basis: 100%;
  flex-grow: 0;
  flex-shrink: 1;
}

:host {
  display: flex;
  width: 100%;
}

mat-form-field {
  width: 100%;
  margin-bottom: 0 !important;
}`, "",{"version":3,"sources":["webpack://./src/app/shared/components/generic-autocomplete/generic-autocomplete.component.scss"],"names":[],"mappings":"AAAA;EACE,gBAAA;EACA,YAAA;EACA,cAAA;AACF;;AAGA;EACE,aAAA;EACA,WAAA;AAAF;;AAGA;EACE,WAAA;EACA,2BAAA;AAAF","sourcesContent":[".generic-autocomplete {\r\n  flex-basis: 100%;\r\n  flex-grow: 0;\r\n  flex-shrink: 1;\r\n}\r\n\r\n\r\n:host {\r\n  display: flex;\r\n  width: 100%;\r\n}\r\n\r\nmat-form-field {\r\n  width: 100%;\r\n  margin-bottom: 0 !important;\r\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
